<script setup lang="ts">
export interface Props {
  errors?: string[];
}

const props = withDefaults(defineProps<Props>(), {
  errors: () => [],
});
</script>

<template>
  <section
    :class="$style.jobBookingErrorPanel"
    data-testid="jobBookingErrorPanel"
    role="alert"
  >
    <v-icon icon="mdi-information" size="18" :class="$style.icon" />
    <div :class="$style.content">
      <span :class="$style.title">Error</span>
      <ul :class="$style.list">
        <li
          v-for="(error, index) in props.errors"
          :key="index"
          :class="$style.item"
        >
          {{ error }}
        </li>
      </ul>
    </div>
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';

.jobBookingErrorPanel {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px 20px;
  border-radius: 8px;
  background: colors.$color-orange-50;
}

.icon {
  color: colors.$color-yellow-500;
  flex-shrink: 0;
  margin-top: 1px;
}

.content {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.title {
  font-size: 0.875rem;
  font-weight: 600;
  color: colors.$color-text-primary;
}

.list {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin: 0;
  padding-left: 0;
  list-style: none;
}

.item {
  font-size: 0.8125rem;
  color: colors.$color-text-primary;
  word-break: break-word;
}
</style>
